import { appAssetsCdnUrl } from '~/constants/environment';

const assetsPath = `${appAssetsCdnUrl}/geolocation-assets`;

export const geoModalAssets = {
  desktopDeliveryImage: `${assetsPath}/delivery-desktop.png`,
  desktopDeliveryVideo: `${assetsPath}/delivery-desktop.mp4`,
  vMDesktopImage: `${assetsPath}/vm-desktop.png`,
  vMDesktopVideo: `${assetsPath}/vm-desktop.mp4`
};
